import { KEYCLOAK_INITIALIZATION } from '../actions/actionTypes';

const initialState = {
    keycloak: null,
};

function keycloakReducer(state = initialState, action) {
    switch (action.type) {
        case KEYCLOAK_INITIALIZATION:
            return { keycloak: action.payload };

        default:
            return { ...state };
    }
}
export default keycloakReducer;



// WEBPACK FOOTER //
// ./src/reducers/keycloak.js